export default "__VITE_ASSET__458b079a__"